import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { type Repository } from '../api/code-forge/interface';
import { baseBranch } from '../util/consts';

type ConfigState = {
    githubToken?: string;
    pushRepository?: Repository;
    pushBranch: string;
    commitDirectly: boolean;

    diffView: 'unified' | 'split';

    setGithubToken: (token: string) => void;
    setPushRepository: (repository?: Repository) => void;
    setPushBranch: (branch: string) => void;
    setCommitDirectly: (commitDirectly: boolean) => void;

    setDiffView: (view: 'unified' | 'split') => void;
};

export const useConfigStore = create<ConfigState>()(
    persist(
        (set) => ({
            githubToken: undefined,
            pushRepository: undefined,
            pushBranch: baseBranch,
            commitDirectly: false,
            diffView: 'split',

            setGithubToken: (token: string) => set({ githubToken: token }),
            setPushRepository: (repository?: Repository) => set({ pushRepository: repository, pushBranch: baseBranch }),
            setPushBranch: (branch: string) => set({ pushBranch: branch }),
            setCommitDirectly: (commitDirectly: boolean) => set({ commitDirectly }),

            setDiffView: (view: 'unified' | 'split') => set({ diffView: view }),
        }),
        { name: 'data-editor-config', version: 1 }
    )
);
